<div
  class="jumbotron-fluid mt-xl-0 pt-4 pt-sm-1 pt-md-3 pt-xl-0 px-lg-4 mb-0 pb-0 pb-sm-3 pb-md-4 pb-lg-5 pb-xl-0 mx-auto">
  <div class="container mt-2 mt-md-4 mt-xl-2 mb-2 mx-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h2 class="rub-head4 text-info text-center font-weight-bold py-1">
          Analysis
        </h2>
      </div>
    </div>
  </div>
  <div class="components row mt-2 mt-xl-0 pt-0 pt-md-2 pt-xl-1">
    <div class="col-12">
      <div class="big-card-2 card shadow-lg mb-3 pb-0 mx-auto">
        <div class="big-card-body-2 card-body mx-auto px-auto mt-0 mt-md-3 mt-xl-0 mb-0 pb-0">
          <div class="row">
            <div
              class="col-xs-12 col-md-11 col-lg-11 col-xl-8 d-flex justify-content-center align-items-center mx-md-4 mx-lg-0 mx-xl-3">
              <canvas ngChartjs [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
                [legend]="lineChartLegend" [chartType]="lineChartType" [inlinePlugins]="inlinePlugin" real-time>
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>